"use client"
import Image from "next/image"
import Link from "next/link"
import { useState } from "react"

const PortesClesSlides = ({ from, to, ClesProduct }) => {
    // imgNum is a number that indicates which img should be shown [0,1,2,3,4,5]
    const [imgNum, setImgNum] = useState(from)
    // If imgNum == 5, it should go back to img 0, otherwise, it moves to the next img
    const plus = () => {
        imgNum == to ? setImgNum(from) : setImgNum(imgNum + 1)
    }
    // If imgNum == 0, it should go to img 5, otherwise, it goes back to the previous img
    const minus = () => {
        imgNum == from ? setImgNum(to) : setImgNum(imgNum - 1)
    }
    return (
        <div className="flex w-full items-center overflow-hidden">
            <Image src={"/icons/portesClesFleshLeft.png"} width={56} height={36} className="w-[20px] h-[15px] lg:w-[56px] lg:h-[36px] -mr-[20px] lg:-mr-[56px] cursor-pointer z-10"
                alt='icon-flesh-right'
                onClick={minus}
            />
            <Link href={`/product/${ClesProduct[imgNum]?.categories}/${ClesProduct[imgNum]?._id}`} className="w-full flex justify-center items-center">
                <img src={ClesProduct[imgNum]?.isClesPhotoPrimary ? ClesProduct[imgNum]?.isClesPhotoPrimary : ClesProduct[imgNum]?.image} width={3000} height={3000} className="max-w-[80%] max-h-[80%]"
                    alt='Portes-Clés-Photo'
                />
            </Link>
            <Image src={"/icons/portesClesFleshRight.png"} width={56} height={36} className="w-[20px] h-[15px] lg:w-[56px] lg:h-[36px] -ml-[20px] lg:-ml-[56px] cursor-pointer z-10"
                onClick={plus}
                alt='icon-flesh-left'
            />
        </div>
    )
}
export default PortesClesSlides